import {useContext} from "react";
import GlobalContext     from "../../../isp._comun/iu/contexto/GlobalContext";
import VentanaItem       from "../../../isp.iu.items/reductores/ventanas/VentanaItem";
import VentanaQueryItems from "../../../isp.iu.items/reductores/ventanas/VentanaQueryItems";
import VentanaPlan       from "../../../isp.iu.planes/reductores/ventanas/VentanaPlan";
import VentanaQueryPlanes from "../../../isp.iu.planes/reductores/ventanas/VentanaQueryPlanes";
// import AbrirVentana      from "../../reductores/acciones/widgets/AbrirVentana";


export default function MenuItemsCatalogo(dispatch) {
    const {
        // dispatchPrincipal,
        // abrirNuevaVentana,
        abrirVentana,
    } = useContext(GlobalContext);
    return [
        {
            label: "Nuevo Plan",
            icon: "pi pi-fw pi-plus",
            command: () => {
                // const nuevaVentana = new VentanaPlan();
                // abrirNuevaVentana(nuevaVentana);
                const nuevaVentana = VentanaPlan.nuevaVentanaEnModoCrear();
                                // const nuevaVentana = new VentanaCliente();
                abrirVentana(nuevaVentana);
                // dispatchPrincipal(new AbrirVentana(nuevaVentana));
            },
        },
        {
            label: "Listar Planes",
            icon: "pi pi-fw pi-list",
            command: () => {
                const nuevaVentana = new VentanaQueryPlanes();
                abrirVentana(nuevaVentana);
                // dispatchPrincipal(new AbrirVentana(nuevaVentana));
                // dispatch(new AbrirVentanaQueryClientesAFacturar())
            },
        },
        {
            separator: true,
        },
        {
            label: "Nuevo Item",
            icon: "pi pi-fw pi-plus",
            command: () => {
                const nuevaVentana = new VentanaItem();
                abrirVentana(nuevaVentana);
                // dispatchPrincipal(new AbrirVentana(nuevaVentana));
            },
        },
        {
            label: "Listar Items",
            icon: "pi pi-fw pi-list",
            command: () => {
                const nuevaVentana = new VentanaQueryItems();
                abrirVentana(nuevaVentana);
                // dispatchPrincipal(new AbrirVentana(nuevaVentana));
                // dispatch(new AbrirVentanaQueryClientesAFacturar())
            },
        },
    ];
}
